module.exports = __webpack_public_path__ + "static/media/aifclogo.4ae52175.svg";